import axios, { AxiosError } from 'axios'

import environment from '@/environment'

import fetchClient, { ApiResponse } from '../api-client'
import { LoginResponse } from './types/LoginResponse'
import { SignupData } from './types/SignupData'

const directApiClient = axios.create({
  baseURL: environment.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  maxContentLength: 3 * 1024 * 1024, // 3 MB
  maxBodyLength: 3 * 1024 * 1024, // 3 MB
})

export async function registerForTest(phoneQuery: string, emailQuery: string, signUpData: SignupData) {
  try {
    const payload = {
      phoneQuery,
      emailQuery,
      signUpData,
    }

    const res = await directApiClient.post(`/auth/register`, payload)

    return res.data.data
  } catch (err) {
    throw err
  }
}

export async function verify(email: string, verify_code: string) {
  try {
    const payload = {
      email,
      verify_code,
    }
    const res = await fetchClient.post(`/auth/verify`, payload)
    //const res = await axios.post(`${BASEURL}/auth/verify`, payload)
    return res.data
  } catch (err) {
    if (err instanceof AxiosError && err.response && err.response.data) {
      throw err.response.data
    }
    throw err
  }
}

export async function login(username: string, password: string, version: string) {
  try {
    const payload = {
      username,
      password,
      version,
    }

    const res = await fetchClient.post<ApiResponse<LoginResponse>>(`/auth/login`, payload)

    return res.data
  } catch (err) {
    // Handle the new error structure with Hebrew messages
    if (err instanceof AxiosError && err.response && err.response.data) {
      throw err.response.data
    }
    throw err
  }
}

export async function getNewPassword(username: string) {
  try {
    const payload = {
      username,
    }

    const res = await fetchClient.post(`/auth/forgotPassword`, payload)
    //const res = await axios.post(`${BASEURL}/auth/forgotPassword`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function updatePassword(username: string, forgotPasswordConfirmationCode: string, forgotPasswordNewPassword: string) {
  try {
    const payload = {
      username,
      forgotPasswordConfirmationCode,
      forgotPasswordNewPassword,
    }

    const res = await fetchClient.post(`/auth/updatePassword`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function changePassword(currentPassword: string, newPassword: string) {
  try {
    const payload = {
      currentPassword,
      newPassword,
    }

    const res = await fetchClient.post(`/auth/changePassword`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}

export async function adminConfirmUser(username: string) {
  try {
    const response = await fetchClient.post('/auth/admin-confirm-user', {
      username,
    })
    return response
  } catch (error) {
    console.error('Error confirming user:', error)
    throw error
  }
}

export async function addUserToGroups(username: string, groups: string[]) {
  try {
    const response = await fetchClient.post('/auth/add-to-groups', {
      username,
      groups,
    })

    return response.data
  } catch (error) {
    console.error('Error adding user to groups:', error)
    throw error
  }
}
